<template lang="pug">
  .userContact.white(:class="contactList ? '' : 'elevation-2'")
    v-card.elevation-0.fill-height(v-rc-loader="loading")
      v-layout.justify-space-between.column.pb-2
        v-card-actions.pl-3.pr-3
          v-layout.justify-end
            slot(name="prependActions")
        v-card-text
          v-form(v-if="user" v-model="valid" ref="userForm")
            v-layout.contactInfo.wrap
              v-flex.xs8
                v-radio-group.pl-2.pt-0.mt-0.mb-2(
                  row hide-details
                  :value="user.gender"
                  @change="editContact('gender', $event)"
                  :disabled="context === 'readonly'"
                )
                  v-radio(label="Mr." color="primary" value="m")
                  v-radio(label="Mme." color="primary" value="f")
                v-text-field(
                  data-test="contact-first-name-field"
                  :value="user.first_name"
                  @input="editContact('first_name', $event)"
                  full-width
                  label="Prénom"
                  :disabled="context === 'readonly'"
                )
                v-text-field(
                  data-test="contact-last-name-field"
                  :value="user.last_name"
                  @input="editContact('last_name', $event)"
                  full-width
                  label="Nom"
                  :disabled="context === 'readonly'"
                )
                //- v-text-field(
                  data-test="userContactFunctionInput"
                  :value="user.function"
                  @input="editContact(user.id, 'function', $event)"
                  full-width
                  label="Poste"
                  :disabled="context === 'readonly'"
                  )
              v-flex.xs4
                rc-uploader(
                  grayscale
                  :url="user.has_image ? `/v2/erp/${$route.path.startsWith('/users') ? 'users' : 'ambassador/contacts'}/${user.id}/image/medium?t=${user.write_date}`: null"
                  @upload="uploadAvatar"
                  @remove="removeAvatar"
                  @error="uploadError" :readonly="context === 'readonly'"
                  v-if="user.image_url || (context !== 'readonly')"
                )
              v-flex.xs12.px-2.mx-1.mb-3(v-if="context === 'add' && !$route.path.startsWith('/users')")
                rc-contact-type-selector(:selectedIds="user.type_ids" @change="editType" :watch="typesWatch")
              v-flex.xs12.px-2.mx-1.mb-3.mt-2(v-else-if="!$route.path.startsWith('/users')")
                rc-contact-type-selector(:selectedIds="user.type_ids" @change="editType")
              v-flex.xs12.px-2.mx-1.mb-3.mt-2(v-else)
              //- v-flex.xs12.px-1.mb-1.mt-3(v-else-if="user.types")
                .subheading.ml-2 {{user.functions.join(', ').toUpperCase() }}
              div.pb-3.px-2.mx-1(v-if="!$route.path.startsWith('/users') && !contactList && !this.$store.state.app.user.touristicProvider && !['create','add'].includes(context)")
                div.caption.theme--light.v-label Associé au compte
                span.subheading.router-link.click(@click="$router.push({ name: 'client_contacts', params: { clientId: user.parent_id } })")  {{ user.parent_name }}
            //- v-divider
            v-flex.xs12.py-3(v-if="user.parent_id && user.parent_name && $store.state.app.destination.id === 1")
              v-layout.align-center.subheading
                span.label.ml-2.pl-1.grey--text.text--darken-2 Accès STUDIO : 
                span.error--text.pl-2(v-if="!user.user") Non
                span.success--text.pl-2(v-else-if="user.user.has_password") Oui
                span.warning--text.pl-2(v-else) En cours d'activation
            v-divider
            .contactDetails(v-if="!contactList")
              .detail
                v-text-field.align-center.mt-2(
                  data-test="contact-phone-field"
                  :value="user.phone"
                  @input="editContact('phone', $event)"
                  prepend-icon="phone"
                  full-width
                  label="Télephone"
                  :rules="[rules.phone]"
                  :disabled="context === 'readonly'"
                )
              v-divider
              .detail
                v-text-field.align-center.mt-3(
                  data-test="contact-mobile-field"
                  :value="user.mobile"
                  @input="editContact('mobile', $event)"
                  prepend-icon="phone_android"
                  full-width
                  label="Mobile"
                  :rules="[rules.phone]"
                  :disabled="context === 'readonly'"
                )
              v-divider
              .detail
                v-text-field.align-center.mt-3(
                  data-test="contact-email-field"
                  :value="user.email"
                  @input="editContact('email', $event)"
                  prepend-icon="email"
                  full-width
                  label="Email"
                  :rules="[rules.email]"
                  :disabled="context === 'readonly'"
                )
              v-divider
              .detail
                v-layout.row.wrap
                  v-flex.xs6
                    v-text-field.align-center.mt-3(
                      data-test="contact-city-field"
                      :value="user.city"
                      @input="editContact('city', $event)"
                      prepend-icon="place"
                      full-width
                      label="Ville"
                      :disabled="context === 'readonly'"
                    )
                  v-flex.xs4
                    v-text-field.align-center.mt-3(
                      data-test="contact-zip-field"
                      :value="user.zip"
                      @input="editContact('zip', $event)"
                      full-width
                      label="Code postal"
                      :rules="[rules.zipcode]"
                      :disabled="context === 'readonly'"
                    )
                  v-flex.xs6
                    v-autocomplete.mt-3(
                      data-test="contact-country-field"
                      ref="countrySelect"
                      :items="countries"
                      prepend-icon="place"
                      label="Pays"
                      item-text="name"
                      item-value="id"
                      return-object
                      :disabled="context === 'readonly'"
                      :value="user.country_id || '72'"
                      @input=`editContact('country_id', $event.id);
                        editContact('country_code', $event.code);`
                      @blur="$refs.countrySelect.isFocused = false; $refs.countrySelect.isMenuActive = false;"
                    )
              v-divider
              .detail
                v-text-field.align-center.mt-3(
                  v-if="user.user"
                  :value="user.user.login"
                  full-width
                  label="Login"
                  prepend-icon="account_box"
                  disabled
                )
              v-divider
              rc-custom-fields.mt-2(
                v-if="user.id" type="contact" :entityId="user.id"
                @loading="value => { $emit('loading', value); }"
                ref="customFields"
              )
        v-card-actions
          v-layout(row justify-end)
          v-btn.error(@click="close" v-if="context === 'add'") Annuler
          v-btn.success(@click="create" data-test="create-contact-confirm" v-if="context === 'add'") Valider
          slot(name="appendActions")
    v-dialog(v-model="dialog" width="30%")
      v-card
        v-card-title.headline Upload d'image impossible
        v-card-text L'image est trop grande
        v-card-actions
          v-spacer
          v-btn(color="primary" flat @click="dialog=false") Fermer
</template>

<script>
import RcUploader from '@/components/RcUploader/RcUploader.vue';
import RcCustomFields from '@/components/RcClients/RcCustomFields.vue';
import RcContactTypeSelector from '@/components/RcContactTypeSelector.vue';
import rcDebounce from '@/mixins/rcDebounce';
import axios from 'axios';
import apiContactService from '@/services/api/ambassador/contactService';
import apiUserService from '@/services/api/common/userService';
import apiTypeService from '@/services/api/common/typeService';

export default {
  components: {
    RcUploader,
    RcCustomFields,
    RcContactTypeSelector,
  },
  mixins: [
    rcDebounce,
  ],
  props: {
    parentId: {
      type: [String, Number],
      default: 'none',
    },
    context: {
      type: String,
      default: 'modify',
    },
    contactType: {
      type: String,
      default: 'contact',
    },
    contactList: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      dialog: false,
      loading: false,
      savePending: false,
      uploaderErrorMessage: '',
      imageFile: '',
      rules: {
        phone: v => /((((\+33)|0))\s?(\(0\))?\d(\s|-|\.)?(\d{2}(\s|-|\.)?){4})|^$/.test(v) || v === null || v === undefined || 'Télephone invalide',
        required: v => !!v || 'Champ obligatoire',
        email: v => /(^[-.a-zA-Z0-9_]*(\.[-a-zA-Z0-9_]+)*@[-a-zA-Z0-9_]+(\.[-a-zA-Z0-9_]+)*\.[a-zA-Z]{2,4}$)|^$/.test(v) || v === null || v === undefined || 'Email invalide',
        zipcode: v => /(^[0-9]{5,5}$)|^$/.test(v) || v === null || v === undefined || 'Code postal invalide',
      },
      typesWatch: false,
    };
  },
  mounted() {
    if (['create', 'add'].includes(this.context)) {
      this.$store.dispatch('contacts/setSelected', { country_id: 76, gender: 'm' });
    }
  },
  computed: {
    countries() {
      return this.$store.state.countries.countries;
    },
    authorizedAmbassadorConfigs() {
      return this.$store.state.contacts.types || [];
    },
    user() {
      return this.contactList ? this.contact : this.$store.state.contacts.selectedContact;
    }
  },
  methods: {
    async editType(val) {
      this.editContact('type_ids', val);
    },
    uploadError(e) {
      this.uploaderErrorMessage = e.code;
      this.dialog = true;
    },
    async uploadAvatar(file) {
      if (this.context === 'modify') {
        !this.$route.path.startsWith('/users') ? await apiContactService.uploadLogoById(this.user.id, file, file.type) : await apiUserService.uploadLogoById(this.user.id, file, file.type);
        this.$emit('postAvatar');
      } else {
        this.transientFile = file;
      }
    },
    async removeAvatar() {
      if (this.context === 'modify') {
        !this.$route.path.startsWith('/users') ? await apiContactService.deleteLogoById(this.user.id) : await apiUserService.deleteLogoById(this.user.id);
        this.$emit('deleteAvatar');
      } else {
        this.transientFile = null
      }
    },
    close() {
      this.$emit('close');
    },
    editContact(field, value) {
      if (this.contactList) {
        this.$emit('edited', { field, value });
        return;
      }
      this.$store.dispatch('contacts/editContact', { field, value });
      this.typesWatch = !this.typesWatch;
      if (this.context === 'modify') {
        this.savePending = true;
        this.rcDebounce(this.create, 200);
      }
    },
    async create() {
      if (!!this.$refs.userForm && this.$refs.userForm.validate()) {
        if (this.context === 'modify') {
          this.savePending = false;
          !this.$route.path.startsWith('/users') ? apiContactService.put(this.user.id, this.$store.state.contacts.selectedContact) : apiUserService.put(this.user.id, this.$store.state.contacts.selectedContact);
          this.$store.dispatch('contacts/getSearchTypes');
        } else {
          this.loading = true;
          if (!this.$route.path.startsWith('/users')) {
            this.editContact('parent_id', this.parentId);
          }
          const newContactId = !this.$route.path.startsWith('/users') ? await apiContactService.create(this.$store.state.contacts.selectedContact) : await apiUserService.create(this.$store.state.contacts.selectedContact);
          if (this.transientFile && newContactId) {
            !this.$route.path.startsWith('/users') ? await apiContactService.uploadLogoById(newContactId, this.transientFile, this.transientFile.type) : await apiUserService.uploadLogoById(newContactId, this.transientFile, this.transientFile.type);
          }
          this.$store.dispatch('contacts/getSearchTypes');
          this.loading = false;
          this.$emit('close');
          this.$emit('created', newContactId);
        }
      }
    },
  },
  beforeDestroy() {
    if (this.savePending) {
      this.create();
    }
  },
  destroyed() {
    if (!this.contactList) {
      this.$store.dispatch('contacts/setSelected', null);
    }
  },
};
</script>

<style lang="scss">
.userContact {
  .router-link {
    color: #015a94;
  }
  .v-form {
    .v-text-field__details {
      margin: 0;
    }
    .v-text-field:not(.error--text) {
      .v-text-field__details {
        display: none;
      }
      .v-input__slot {
        margin: 0;
      }
    }
    .detail {
      .v-input.v-select {
        padding-top: 0px;
        .v-input__control {
          padding-left: 10px;
        }
      }
    }
  }
  .v-text-field__suffix {
    color: red;
  }
  .contactDetails {
    .v-text-field.v-text-field--full-width .v-input__control {
      padding-bottom: 5px;
    }
  }
  .contactInfo {
    .v-text-field.v-text-field--full-width .v-input__control {
      padding: 0px;
    }
  }
}
.image-box img {
  width: 40px;
  height: 40px;
}
.uploader-button {
  border-radius: 50%;
}
</style>
